import { render, staticRenderFns } from "./customer-view.vue?vue&type=template&id=44cd3d8c&scoped=true"
import script from "./customer-view.vue?vue&type=script&lang=js"
export * from "./customer-view.vue?vue&type=script&lang=js"
import style0 from "./customer-view.vue?vue&type=style&index=0&id=44cd3d8c&prod&lang=css"
import style1 from "./customer-view.vue?vue&type=style&index=1&id=44cd3d8c&prod&scoped=true&lang=css"
import style2 from "./customer-view.vue?vue&type=style&index=2&id=44cd3d8c&prod&scoped=true&lang=css"
import style3 from "./customer-view.vue?vue&type=style&index=3&id=44cd3d8c&prod&lang=css"
import style4 from "./customer-view.vue?vue&type=style&index=4&id=44cd3d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd3d8c",
  null
  
)

export default component.exports